import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import Panel from '../../shared/components/Panel';
import CardPanel from '../../shared/components/widgets/CardPanel';
import CreateCustomer from './account/CreateCustomerForm';
import CreateAccount from './account/CreateAccountForm';
import useClientMenuData from '../Layout/sidebar/useClientMenuData';

const amazonIcon = require('../../shared/img/logo/amazonIcon.png');
const dspIcon = require('../../shared/img/logo/dspIcon.png');
const walmartIcon = require('../../shared/img/logo/walmartIcon.png');

export default function Onboarding() {
  const sellerSelect = useSelector(store => store.sellerSelect);
  const user = useSelector(store => store.authentication.user);
  const clientMenuData = useClientMenuData(sellerSelect);
  const sectionControl = clientMenuData?.sectionControl;
  const defaultTab = () => {
    if (sellerSelect.value === 1) {
      return 'account';
    }
    if (sellerSelect && sellerSelect.value > 0 && sellerSelect.type !== 4 && sellerSelect.value !== 123 && sellerSelect.value !== 1) {
      return 'amazon';
    }
    if (((sellerSelect && sellerSelect.value > 0 && sellerSelect.value === 123) || (user.access === 'admin')) && sellerSelect.value !== 1) {
      return 'walmart';
    }
    if (user.access === 'admin' && sellerSelect.value !== 123 && sellerSelect.value !== 1) {
      return 'dsp';
    }
    return '';
  }
  const [activeTab, setActiveTab] = useState(defaultTab());

  return (
    <Container className="dashboard">
      <div className="profile__card tabs tabs--bordered-bottom">
        <div className="tabs__wrap">
          <Nav tabs>
            {sellerSelect.value === 1 && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 'customer' })}
                  onClick={() => {
                    setActiveTab('customer');
                  }}
                >
                  <span className={'sidebar__link-icon lnr lnr-user'} /> Customer <span style={{ paddingLeft: '30px' }}> </span>
                </NavLink>
              </NavItem>
            )}
            {sellerSelect.value === 1 && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 'account' })}
                  onClick={() => {
                    setActiveTab('account');
                  }}
                >
                  <span className={'sidebar__link-icon lnr lnr-users'} /> Accounts <span style={{ paddingLeft: '30px' }}> </span>
                </NavLink>
              </NavItem>
            )}
            {sellerSelect && sellerSelect.value > 0 && sellerSelect.type !== 4 && sellerSelect.value !== 123 && sellerSelect.value !== 1 && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 'amazon' })}
                  onClick={() => {
                    setActiveTab('amazon');
                  }}
                >
                  <span
                    className={'tab-img'}
                    style={{
                      background: `url(${amazonIcon})`, backgroundPosition: 'left', backgroundRepeat: 'no-repeat', cursor: 'default', backgroundSize: '20px 20px',
                    }}
                  /> Amazon <span style={{ paddingLeft: '30px' }}> </span>
                </NavLink>
              </NavItem>
            )}
            {user.access === 'admin' && sellerSelect.value !== 123 && sellerSelect.value !== 1 && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 'dsp' })}
                  onClick={() => {
                    setActiveTab('dsp');
                  }}
                >
                  <span
                    className={'tab-img'}
                    style={{
                      background: `url(${dspIcon})`, backgroundPosition: 'left', backgroundRepeat: 'no-repeat', cursor: 'default', backgroundSize: '20px 20px',
                    }}
                  /> DSP <span style={{ paddingLeft: '30px' }}> </span>
                </NavLink>
              </NavItem>
            )}
            {((sellerSelect && sellerSelect.value > 0 && sellerSelect.value === 123) || (user.access === 'admin') || (sectionControl && sectionControl.walmart)) && sellerSelect.value !== 1 && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 'walmart' })}
                  onClick={() => {
                    setActiveTab('walmart');
                  }}
                >
                  <span
                    className={'tab-img'}
                    style={{
                      background: `url(${walmartIcon})`, backgroundPosition: 'left', backgroundRepeat: 'no-repeat', cursor: 'default', backgroundSize: '20px 20px',
                    }}
                  /> Walmart <span style={{ paddingLeft: '30px' }}> </span>
                </NavLink>
              </NavItem>
            )}
            {user.access === 'admin' && sellerSelect.value !== 123 && sellerSelect.value !== 1 && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 'google' })}
                  onClick={() => {
                    setActiveTab('google');
                  }}
                >
                  <span className={'sidebar__link-icon lnr lnr-hourglass'} /> Google <span style={{ paddingLeft: '30px' }}> </span>
                </NavLink>
              </NavItem>
            )}
            {user.access === 'admin' && sellerSelect.value !== 123 && sellerSelect.value !== 1 && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 'target' })}
                  onClick={() => {
                    setActiveTab('target');
                  }}
                >
                  <span className={'sidebar__link-icon lnr lnr-hourglass'} /> Target <span style={{ paddingLeft: '30px' }}> </span>
                </NavLink>
              </NavItem>
            )}
            {user.access === 'admin' && sellerSelect.value !== 123 && sellerSelect.value !== 1 && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 'linkedin' })}
                  onClick={() => {
                    setActiveTab('linkedin');
                  }}
                >
                  <span className={'sidebar__link-icon lnr lnr-hourglass'} /> LinkedIn <span style={{ paddingLeft: '30px' }}> </span>
                </NavLink>
              </NavItem>
            )}
            {user.access === 'admin' && sellerSelect.value !== 123 && sellerSelect.value !== 1 && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 'instacart' })}
                  onClick={() => {
                    setActiveTab('instacart');
                  }}
                >
                  <span className={'sidebar__link-icon lnr lnr-hourglass'} /> Instacart <span style={{ paddingLeft: '30px' }}> </span>
                </NavLink>
              </NavItem>
            )}
          </Nav>
          <TabContent activeTab={activeTab}>
            {sellerSelect.value === 1 && (
              <TabPane tabId="customer">
                <CardPanel
                  showButtons={false}
                  title="Add New Customer"
                >
                  <CreateCustomer />
                </CardPanel>
              </TabPane>
            )}
            {sellerSelect.value === 1 && (
              <TabPane tabId="account">
                <CardPanel
                  showButtons={false}
                  title="Add New Account"
                >
                  <CreateAccount />
                </CardPanel>
              </TabPane>
            )}
            {sellerSelect && sellerSelect.value > 0 && sellerSelect.type !== 4 && sellerSelect.value !== 123 && sellerSelect.value !== 1 && (
              <TabPane tabId="amazon">
                <CardPanel
                  showButtons={false}
                  title={`Amazon API onboarding options for ${sellerSelect.label}`}
                >
                  <Panel
                    title="Amazon Add Advertising API"
                    showRefreshButton={false}
                    border
                  >
                    <Row>
                      <Col md={3}>
                        <p>
                          Requirments:
                          <li>Account Type: Seller/Vendor</li>
                          <li>Country</li>
                          <li>Name</li>
                          <li>Admin access to Amazon</li>
                        </p>
                      </Col>
                      <Col md={6}>
                        <p>This will create a new Limitless account and link it to your Customer record.  This is typically used when you are adding a new marketplace.</p>
                      </Col>
                    </Row>
                    <Row>
                      <br />
                    </Row>
                    <Row>
                      <Link className="btn btn-outline-primary account__btn_fit_content" to="/customer/onboarding/ad-api/start">Start Amazon AD API Onboard</Link>
                    </Row>
                  </Panel>
                  <Panel
                    title="Amazon Onboard Selling Partner API"
                    showRefreshButton={false}
                    border
                  >
                    <Row>
                      <Col md={3}>
                        <p>
                          Requirments:
                          <li>Onboarded Advertising API</li>
                          <li>Select the Account you want to add/update SP-API</li>
                          <li>Admin access to Amazon</li>
                        </p>
                      </Col>
                      <Col md={6}>
                        <p>Onboard Selling Partner API to <strong>{sellerSelect.label}</strong>.  This is recommended right after you onboard a Advertising API, it allows us to capture additional data for your account.</p>
                      </Col>
                    </Row>
                    <Row>
                      <br />
                    </Row>
                    <Row>
                      <Link className="btn btn-outline-primary account__btn_fit_content" to="/customer/onboarding/sp-api/start">Start Amazon SP API Onboard</Link>
                    </Row>
                  </Panel>
                </CardPanel>
              </TabPane>
            )}
            {user.access === 'admin' && sellerSelect.value !== 123 && sellerSelect.value !== 1 && (
              <TabPane tabId="dsp">
                <CardPanel
                  showButtons={false}
                  title={`Amazon DSP onboarding options for ${sellerSelect.label}`}
                >
                  <Panel
                    title="Amazon Onboard DSP"
                    showRefreshButton={false}
                    border
                  >

                    <Row>
                      <Col md={3}>
                        <p>
                          Requirments:
                          <li>DSP Advertiser(s))</li>
                          <li>DSP Region to select the correct Manager</li>
                        </p>
                      </Col>
                      <Col md={6}>
                        <p>This will link DSP to <strong>{sellerSelect.label}</strong>.</p>
                      </Col>
                    </Row>
                    <Row>
                      <br />
                    </Row>
                    <Row>
                      <Link className="btn btn-outline-primary account__btn_fit_content" to="/customer/onboarding/dsp">Link DSP Account</Link>
                    </Row>
                  </Panel>
                </CardPanel>
              </TabPane>
            )}
            {((sellerSelect && sellerSelect.value > 0 && sellerSelect.value === 123) || (user.access === 'admin') || (sectionControl && sectionControl.walmart)) && sellerSelect.value !== 1 && (
              <TabPane tabId="walmart">
                <CardPanel
                  showButtons={false}
                  title={`Walmart onboarding options for ${sellerSelect.label}`}
                >
                  <Panel
                    title="Walmart Link Adevertising API"
                    showRefreshButton={false}
                    border
                  >
                    <Row>
                      <Col md={6}>
                        <p>
                          Requirments:
                          <li>Admin access to your Walmart Advertiser account</li>
                          <li>Advertiser ID</li>
                          <li>Advertiser Name</li>
                          <li>Advertiser Type - 1p or 3p</li>
                          <li>Seller ID (only required for 3p)</li>
                          <li>Seller Name (only required for 3p)</li>
                        </p>
                      </Col>
                      <Col md={6}>
                        <p>Link you current Walmart AD-API to <strong>{sellerSelect.label}</strong>.</p>
                      </Col>
                    </Row>
                    <Row>
                      <br />
                    </Row>
                    <Row>
                      <Link className="btn btn-outline-primary account__btn_fit_content" to="/customer/onboarding/walmart/ad-api">Link Walmart AD Account</Link>
                    </Row>
                  </Panel>
                  <Panel
                    title="Walmart Onboard Marketplace API"
                    showRefreshButton={false}
                    border
                  >
                    <Row>
                      <Col md={6}>
                        <p>
                          Requirments:
                          <li>The Walmart Advertiser account you linked to this account is a 3p-Marketplace</li>
                          <li>You are on the account you want to add a Marketplace API connection</li>
                          <li>The Advertising API is already liked to this account</li>
                          <li>Admin access to Walmart Marketplace to approve the connection</li>
                        </p>
                      </Col>
                      <Col md={6}>
                        <p>Link your current Walmart Marketplace API to <strong>{sellerSelect.label}</strong>.  This can be used after you have linked the Walmart Advertising API, it allows us to capture additional data for you account.</p>
                      </Col>
                    </Row>
                    <Row>
                      <br />
                    </Row>
                    <Row>
                      <Link className="btn btn-outline-primary account__btn_fit_content" to="/customer/onboarding/walmart/mp-api">Link Walmart MP Account</Link>
                    </Row>
                  </Panel>
                </CardPanel>
              </TabPane>
            )}
            {user.access === 'admin' && sellerSelect.value !== 123 && sellerSelect.value !== 1 && (
              <TabPane tabId="google">
                <CardPanel
                  showButtons={false}
                  title={`Google onboarding options for ${sellerSelect.label}`}
                >
                  <Panel
                    title="Google APIs"
                    showRefreshButton={false}
                    border
                  >
                    <p>We are connected to Google APIs, but have not automated the onboarding process at this time.</p>
                    <br />
                    <p>Please contact <a href="mailto:adteam@limitless.tech">adteam@limitless.tech</a> if you are intrested in this connection and to get more up to date information.</p>
                  </Panel>
                </CardPanel>
              </TabPane>
            )}
            {user.access === 'admin' && sellerSelect.value !== 123 && sellerSelect.value !== 1 && (
              <TabPane tabId="target">
                <CardPanel
                  showButtons={false}
                  title={`Target onboarding options for ${sellerSelect.label}`}
                >
                  <Panel
                    title="Target APIs"
                    showRefreshButton={false}
                    border
                  >
                    <p>We have tested to the Target APIs, but have not setup an account via the API.  Once we understand the API onboarding flow we will automate linking to it here.</p>
                    <br />
                    <p>Please contact <a href="mailto:adteam@limitless.tech">adteam@limitless.tech</a> if you are intrested in this connection and to get more up to date information.</p>
                  </Panel>
                </CardPanel>
              </TabPane>
            )}
            {user.access === 'admin' && sellerSelect.value !== 123 && sellerSelect.value !== 1 && (
              <TabPane tabId="linkedin">
                <CardPanel
                  showButtons={false}
                  title={`LinkedIn onboarding options for ${sellerSelect.label}`}
                >
                  <Panel
                    title="LinkedIn APIs"
                    showRefreshButton={false}
                    border
                  >
                    <p>We have tested LinkedIn API, but do not have a onbaording flow at this time.</p>
                    <br />
                    <p>Please contact <a href="mailto:adteam@limitless.tech">adteam@limitless.tech</a> if you are intrested in this connection and to get more up to date information.</p>
                  </Panel>
                </CardPanel>
              </TabPane>
            )}
            {user.access === 'admin' && sellerSelect.value !== 123 && sellerSelect.value !== 1 && (
              <TabPane tabId="instacart">
                <CardPanel
                  showButtons={false}
                  title={`Instacart onboarding options for ${sellerSelect.label}`}
                >
                  <Panel
                    title="Instacart APIs"
                    showRefreshButton={false}
                    border
                  >
                    <p>We have only had preliminary discussions with Instacart APIs, but have not activally developed or tested connections.</p>
                    <br />
                    <p>Please contact <a href="mailto:adteam@limitless.tech">adteam@limitless.tech</a> if you are intrested in this connection and to get more up to date information.</p>
                  </Panel>
                </CardPanel>
              </TabPane>
            )}
          </TabContent>
        </div>
      </div>
    </Container>
  )
}
